<template>
        <div class="page">

            <div class="page-view" :style="'background-image:url('+backgroundImage+')'">
                <slot></slot>
            </div>
        </div>
</template>

<script>

    import bg from '@a/img/bg.jpg'
    import Loading from '@c/ui/Loading'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            Loading
        },
        computed: {
            backgroundImage(){
                return bg;
            }
        },
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {},
        mounted: function () {

        },
        name: 'LayoutBase',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">

    .page-view{
        background-position: center right;
        background-repeat: no-repeat;
        background-size: cover;
    }

</style>


// WEBPACK FOOTER //
// src/layouts/Blank.vue